import { CROSS_TENANT_ASSETS_GEOMETRIC_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/assetsGeometricSearch/query';
import { CROSS_TENANT_ASSETS_PART_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/assetsPartSearch/query';
import { CROSS_TENANT_ASSETS_VISUAL_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/assetsVisualSearch/query';
import { CROSS_TENANT_TEXT_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/textsearch/query';
import { CROSS_TENANT_VISUAL_SEARCH_QUERY_KEY } from '@/hooks/api/crossTenant/visualSearch/query';
import { LIST_FOLDER_CONTENTS_QUERY_KEY } from '@/hooks/api/folders/useFetchFolderContents';
import { GET_FOLDER_HIERARCHY_QUERY_KEY } from '@/hooks/api/folders/useFolderHierarchy';
import { QueryClient } from '@tanstack/react-query';
import { ASSET_STATE_COUNTS_QUERY_KEY } from './useGetAssetStateCounts';
import { GET_ASSET_QUERY_KEY } from './useGetAsset';
import { LIST_ASSETS_BY_STATE_QUERY_KEY } from './useFetchAssetsByState';

const listQueryKeys = () => [
  LIST_FOLDER_CONTENTS_QUERY_KEY,
  LIST_ASSETS_BY_STATE_QUERY_KEY,
  ASSET_STATE_COUNTS_QUERY_KEY,
];

const searchAndDetailQueryKeys = () => [
  CROSS_TENANT_TEXT_SEARCH_QUERY_KEY,
  CROSS_TENANT_ASSETS_PART_SEARCH_QUERY_KEY,
  CROSS_TENANT_ASSETS_GEOMETRIC_SEARCH_QUERY_KEY,
  CROSS_TENANT_VISUAL_SEARCH_QUERY_KEY,
  CROSS_TENANT_ASSETS_VISUAL_SEARCH_QUERY_KEY,
  GET_FOLDER_HIERARCHY_QUERY_KEY,
  GET_ASSET_QUERY_KEY,
];

const resetQueries = (queryClient: QueryClient, keys: string[]) => {
  for (const key of keys) {
    void queryClient.resetQueries({ queryKey: [key], exact: false });
  }
};

export const resetAssetListQueries = (queryClient: QueryClient) => {
  resetQueries(queryClient, listQueryKeys());
};

export const resetDeletedAssetQueries = (queryClient: QueryClient) => {
  resetQueries(queryClient, [...listQueryKeys(), ...searchAndDetailQueryKeys()]);
};
